import { api, catchErrorHandler, removeLocalStorage } from "utils/api";

export const signIn = async ({
  phoneNumber,
  passCode,
  appToken,
  deviceOsCode,
  deviceName,
  deviceMacId,
}) => {
  try {
    const { data } = await api.post(`/mobile/sign-in_v2`, {
      phoneNumber,
      passCode,
      appToken,
      deviceOsCode,
      deviceName,
      deviceMacId,
    });

    // 헤더에 전역으로 Authorization 적용
    api.defaults.headers.common["Authorization"] = `Bearer ${data.accessToken}`;
    // localstorage에 토큰 저장
    window.localStorage.setItem("accessToken", data.accessToken);
    window.localStorage.setItem(
      "seqManagerMobileDevice",
      data.seqManagerMobileDevice
    );

    return true;
  } catch (error) {
    return false;
  }
};

export const getAuthNumber = async ({ phoneNumber, name }) => {
  try {
    await api.post(`/mobile/send-sms`, {
      phoneNumber: phoneNumber,
      name: name,
    });
  } catch (error) {
    return catchErrorHandler(error);
  }
};

export const resetPassword = async ({
  phoneNumber,
  passCode,
  authenticationNumber,
}) => {
  try {
    const { status } = await api.post(`/mobile/reset-pass-code`, {
      authenticationNumber,
      phoneNumber,
      passCode,
    });
    return status === 200;
  } catch (error) {
    return catchErrorHandler(error);
  }
};

export const logout = async () => {
  try {
    const { status } = await api.patch(`/mobile/sign-out`);
    if (status === 200) {
      removeLocalStorage();
      return true;
    }
    return false;
  } catch (error) {
    removeLocalStorage();
    return catchErrorHandler(error, "logout", false);
  }
};

export const removeAccount = async () => {
  try {
    const { status } = await api.patch(`/mobile/withdrawal`);
    if (status === 200) {
      removeLocalStorage();
      return true;
    }
    return false;
  } catch (error) {
    return catchErrorHandler(error, "removeAccount");
  }
};
